/*
 *   File : confirmation.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Delete Modal
 *   Integrations : 09-02-2022
 *   Version : v1.0
 */

/*import packages*/
import React, { useEffect, useState } from 'react';
import $ from 'jquery';

/*import componets*/
import { SecondaryBtn } from '../../components/cta/index';
import { Toast } from '../note/index';

/*import styles*/
import styles from '../../styles/components/confirmation.module.scss';


/*import services*/
import devconfig from '../../config/config';
import APIPost from '../../services/postApi';

/* import assets */
import Delete from '../../assets/images/modal/delete.svg'

export default function DeleteFund(props) {

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [loader, setLoader] = useState(false);



    useEffect(() => {
        var myModalEl = document.getElementById("delete-fund")
        myModalEl.addEventListener('hidden.bs.modal', (event) => {
            props.closeModal()

            $(".fade").removeClass("modal-backdrop");
            $("body").removeAttr("style");
        })
        //eslint-disable-next-line
    }, [])


    return (
        <div className={`${styles.e_confirmation} modal fade`} id="delete-fund" tabIndex="-1" aria-labelledby="success" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        {/* <h6>{`Delete ${props?.title}`}</h6> */}
                        <button type="button"
                            className="btn-close"
                            id="close-btn"
                            data-bs-dismiss="modal"
                            aria-label="Close" >
                        </button>
                    </div>
                    <div className="container px-3">
                        <div className="row">
                            <div className='col-lg-12 text-center'>
                                <img src={Delete} alt="" />
                            </div>
                            <div className="col-lg-12 text-center">
                                <p >Are you sure want remove the fund?</p>
                            </div>
                        </div>
                        <div className="row pt-4 pb-2">
                            <div className="col-lg-12">
                                <div className="d-flex justify-content-center">

                                    <SecondaryBtn name="Delete" className={
                                        loader ?
                                            `${styles.e_delete} e-modal-submit e-btn-loader me-3`
                                            :
                                            `${styles.e_delete} e-modal-submit me-3`
                                    }
                                        cancel="modal"
                                        handleClick={() => {
                                            props.deleteFund();


                                        }} />
                                    <SecondaryBtn name="Cancel" className={styles.e_cancel} cancel="modal" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* error toast */}
            {
                error !== null ?
                    <Toast data={error}
                        type="error"
                        id="1"
                    />
                    :
                    null
            }
            {/* success toast */}
            {
                success !== null ?
                    <Toast data={success}
                        type="success"
                        id="2"
                    />
                    :
                    null
            }
        </div>
    );
}
